
export function handleChangeEditor(editor, setCodingGame) {
    setCodingGame((prevCodingGame) => ({
        ...prevCodingGame,
        statement: editor.getData()
    }));
}

export function handleChangeExplanation(editor, setCodingGame) {
    setCodingGame((prevCodingGame) => ({
        ...prevCodingGame,
        solutionCode: editor
    }));
}

export function handleChangeTestsCode(editor, setCodingGame) {
    setCodingGame((prevCodingGame) => ({
        ...prevCodingGame,
        testsCode: editor
    }));
}

export function handleChangeBaseCode(editor, setCodingGame) {
    setCodingGame((prevCodingGame) => ({
        ...prevCodingGame,
        baseCode: editor
    }));
}
